import { Stack, Flex } from "@mantine/core";

import { CalculatorInput, CalculatorSlider, SectionText } from "components";

interface ICalculatorField {
  allowDecimal?: boolean;
  disabled?: boolean;
  inputVariant?: string;
  label: string;
  labelVariant?: string;
  max: number;
  min: number;
  rightSection: any;
  rightSectionWidth: number;
  sliderColor?: string;
  step: number;
}

const CalculatorField = ({
  allowDecimal,
  disabled,
  inputVariant,
  label,
  labelVariant,
  max,
  min,
  rightSection,
  rightSectionWidth,
  sliderColor,
  step,
  ...props
}: ICalculatorField) => {
  return (
    <Stack gap={20}>
      <Flex align={"center"} justify={"space-between"}>
        <SectionText text={label} variant={labelVariant} />
        <CalculatorInput
          rightSection={rightSection}
          rightSectionWidth={rightSectionWidth}
          min={min}
          max={max}
          allowDecimal={allowDecimal}
          variant={inputVariant}
          disabled={disabled}
          label={label}
          {...props}
        />
      </Flex>
      <CalculatorSlider
        color={sliderColor}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        {...props}
      />
    </Stack>
  );
};

export default CalculatorField;
